import { render, staticRenderFns } from "./CompetitionProductsSelector.vue?vue&type=template&id=6974acf6&scoped=true&"
import script from "./CompetitionProductsSelector.vue?vue&type=script&lang=js&"
export * from "./CompetitionProductsSelector.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionProductsSelector.vue?vue&type=style&index=0&id=6974acf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974acf6",
  null
  
)

export default component.exports